import React from "react";
import { Box, Typography, Button } from "@mui/material";

interface RentalHeaderProps {
  title?: string;
  primaryColor?: string;
  actionText?: string;
  onActionClick?: () => void;
  showActionButton?: boolean;
}

const RentalHeader: React.FC<RentalHeaderProps> = ({
  title,
  primaryColor = "#0047C0",
  actionText = "Back",
  onActionClick,
  showActionButton = true,
}) => {
  return (
    <Box sx={[styles.headerContainer, { backgroundColor: primaryColor }]}>
      <Typography variant="h5" sx={styles.headerTitle}>
        {title}
      </Typography>

      {showActionButton && (
        <Button
          onClick={onActionClick}
          variant="outlined"
          sx={styles.actionButton}
        >
          {actionText}
        </Button>
      )}
    </Box>
  );
};

const styles = {
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 9px",
    borderRadius: "9px 9px 0 0",
    color: "white",
  },
  headerTitle: {
    fontWeight: 600,
    color: "white",
    fontSize: "20px",
  },

  // Button styles
  actionButton: {
    position: {
      xs: "relative",
      lg: "fixed",
    },
    top: {
      xs: "auto",
      lg: "16px",
    },
    right: {
      xs: "auto",
      lg: "16px",
    },

    // Override outlined button styles
    borderColor: "white",
    color: "white",
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "8px",
    padding: "8px 16px",
    transition: "all 0.3s ease",

    "&:hover": {
      borderColor: "white",
      backgroundColor: "rgba(255, 255, 255, 0.15)",
      transform: "scale(1.05)",
    },
  },
};

export default RentalHeader;
